import React from 'react';

import { ConfirmationDialog } from 'src/components';

/** The confirmations the skill editor's toolbar asks for: Discard, Publish and Delete. */
export const SkillEditorDialogs = React.memo(function SkillEditorDialogs({
  deleteOpen,
  discardOpen,
  isPublished,
  isShared,
  onCloseDelete,
  onCloseDiscard,
  onClosePublish,
  onConfirmDelete,
  onConfirmDiscard,
  onConfirmPublish,
  publishOpen,
  skillName,
}: {
  deleteOpen: boolean;
  discardOpen: boolean;
  isPublished: boolean;
  isShared: boolean;
  onCloseDelete: () => void;
  onCloseDiscard: () => void;
  onClosePublish: () => void;
  onConfirmDelete: () => void;
  onConfirmDiscard: () => void;
  onConfirmPublish: () => void;
  publishOpen: boolean;
  skillName: string;
}) {
  return (
    <>
      <ConfirmationDialog
        message="Your unpublished changes will be lost. The skill goes back to its published version."
        open={discardOpen}
        primaryText="Discard Changes"
        title="Discard unpublished changes?"
        onClickPrimary={onConfirmDiscard}
        onClose={onCloseDiscard}
      />
      <ConfirmationDialog
        message={
          isShared
            ? 'Everyone with access to this shared skill will use this version and can read its files.'
            : 'Your chats will use this version of the skill from now on.'
        }
        open={publishOpen}
        primaryText={isPublished ? 'Publish Changes' : 'Publish'}
        title="Publish this skill?"
        onClickPrimary={onConfirmPublish}
        onClose={onClosePublish}
      />
      <ConfirmationDialog
        message={`Delete “${skillName}” and all its files? This skill will no longer be available to anyone using it.`}
        open={deleteOpen}
        primaryText="Delete skill"
        title="Delete skill?"
        onClickPrimary={onConfirmDelete}
        onClose={onCloseDelete}
      />
    </>
  );
});
